<template>
  <div>
    <legal-notice v-if="legalText" :text="legalText"></legal-notice>

    <div
      :class="`container container-${theme} ${
        hasFixedButton ? ' container-fixed-button' : ''
      }`"
    >
      <wrap-container class="w100">
        <p
          :class="`title ${showText ? 'title-minus' : 'title-plus'}`"
          @click="toggleText"
          role="heading"
          aria-level="1"
        >
          Términos y condiciones
        </p>
        <hr />
        <footer>
          <transition name="fade">
            <slot v-if="showText">
              <p
                class="titulo p12 book content"
                v-safe-html="text"
                ref="termsContent"
              ></p>
            </slot>
          </transition>
        </footer>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import { ON_TOGGLE_TERMS_AND_CONDITIONS } from "@/config/constants/mutation-types";
import { mapState } from "vuex";
import WrapContainer from "@/components/core/Container";
import LegalNotice from "@/components/core/LegalNotice.vue";

export default {
  name: "AppFooter",
  components: { WrapContainer, LegalNotice },
  props: {
    text: String,
    legalText: String,
    hasFixedButton: Boolean,
    theme: {
      type: String,
      default: "dark"
    }
  },
  data() {
    return {
      isTextVisible: false
    };
  },
  created() {
    this.$root.$on("showOpenTerms", this.scrollToTerms);
  },
  beforeDestroy() {
    this.$root.$off("showOpenTerms", this.scrollToTerms);
  },
  methods: {
    toggleText() {
      this.isTextVisible = !this.showText;
      this.$store.commit(ON_TOGGLE_TERMS_AND_CONDITIONS, this.isTextVisible);
      this.scrollToTerms();
    },
    scrollToTerms() {
      this.$nextTick(() => {
        if (this.showText) {
          const termsContent = this.$refs.termsContent;
          if (termsContent) {
            termsContent.scrollIntoView({ behavior: "smooth" });
            termsContent.focus();
          }
        }
      });
    }
  },
  computed: {
    showText() {
      return this.isTextVisible || this.isTermsVisible;
    },
    ...mapState({
      isTermsVisible: state => state.isTermsVisible
    })
  }
};
</script>

<style scoped>
hr {
  border: 0;
  border-top: 1px solid var(--bbva-color-300);
}

.title {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 18px;
  padding: 0 16px;
  cursor: pointer;
}

div.container-light .title {
  color: #000000;
}

div.container-dark .title {
  color: #e4e4e4;
}

.title-minus::before,
.title-plus::before {
  display: inline-flex;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.title-plus::before {
  content: url("../../assets/img/1x/plus.svg");
}
.title-minus::before {
  vertical-align: middle;
  content: url("../../assets/img/1x/minus.svg");
}

div.container {
  font-size: 12px;
  line-height: 1.5em;
  padding: 21px 17px 32px;
  text-align: justify;
  margin-bottom: 0px;
}

div.container-dark {
  background: #043263;
  color: #e4e4e4;
}

div.container-light {
  background: #e9e9e9;
  color: #000000;
}

div.container-dark p >>> a {
  color: #5bbeff;
  text-decoration: none;
}
div.container-dark p >>> a:hover {
  text-decoration: underline;
}

.content {
  margin-top: 18px;
}

img {
  display: block;
  width: 112px;
  height: auto;
  margin-top: 16px;
}

div.container-fixed-button {
  padding-bottom: 90px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 600px) {
  hr {
    margin: 10px 0;
  }
}

@media screen and (max-width: 1024px) {
  div.container-light .title {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
}
</style>
